import type { SVGProps } from "react";
const SvgMedianSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={33}
    height={33}
    fill="none"
    {...props}
  >
    <g clipPath="url(#Median_SVG_svg__a)">
      <path
        fill="#CFD7E4"
        stroke="#2b385f"
        d="M4.5 16.5h24v16h-24zM4.5-2.5h24v19h-24z"
      />
      <path fill="#DEDEDE" fillOpacity={0.96} d="M4-3h25v36H4z" />
      <path stroke="#2b385f" d="M4 16.5h25" />
      <circle cx={16.5} cy={14.5} r={6} fill="#E3E3E3" stroke="#C3C3C3" />
    </g>
    <defs>
      <clipPath id="Median_SVG_svg__a">
        <path fill="#fff" d="M0 0h33v33H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgMedianSvg;
